/**
 * Check if a string is a valid hex color string
 *
 * @param hex {String} string to evaluate
 * @returns {Boolean} true if valid hex, false otherwise
 */
export const isValidHex = (hex) => /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);

const getChunksFromString = (st, chunkSize) =>
  st.match(new RegExp(`.{${chunkSize}}`, "g"));

const convertHexUnitTo256 = (hexStr) =>
  parseInt(hexStr.repeat(2 / hexStr.length), 16);

const getAlphafloat = (a, alpha) => {
  if (typeof a !== "undefined") {
    return a / 255;
  }
  if (typeof alpha != "number" || alpha < 0 || alpha > 1) {
    return 1;
  }
  return alpha;
};

/**
 * Takes a hex color and returns it in rgba form,
 * if an invalid hex is provided, will return rgba(0, 0, 0, 0)
 *
 * @param hex {String} hex color string to convert
 * @param alpha {Number} opacity desired (between 0 and 1)
 * @returns {String} rgba color string
 */
export const hexToRGBA = (hex, alpha) => {
  if (!isValidHex(hex)) return "rgba(0, 0, 0, 0)";
  const chunkSize = Math.floor((hex.length - 1) / 3);
  const hexArr = getChunksFromString(hex.slice(1), chunkSize);
  const [r, g, b, a] = hexArr.map(convertHexUnitTo256);

  return `rgba(${r}, ${g}, ${b}, ${getAlphafloat(a, alpha)})`;
};
